<template>
  <div class="page-custom">
    <div class="copynum-item">
      <div class="copynum-bg">
        <img class="sub-logo" @click="subCopyNum" src="../assets/sub.svg" />{{
          perNum
        }}份
        <img class="add-logo" @click="addCopyNum" src="../assets/add.svg" />
      </div>
    </div>
    <div class="text-customize">
      <span class="text-zhu">注：</span>请在下面选择您需要打印的个别内容
    </div>
    <van-checkbox-group v-model="nameList">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in selectedArr"
          clickable
          :key="'print' + index"
          :title="item.itemName"
          @click="toggle(index)"
        >
          <van-checkbox
            slot="right-icon"
            :name="item.itemName"
            ref="checkboxes"
            checked-color="#1aad19"
          />
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>

    <!--分割线-->
    <div class="line"></div>
    <van-button
      type="primary"
      size="large"
      class="btn-next"
      safe-area-inset-bottom
      @click="confirm"
      color="#1aad19"
      >确定</van-button
    >
  </div>
</template>

<script>
import Vue from "vue";
import { Checkbox, CheckboxGroup, Cell, CellGroup } from "vant";

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);
let perNum;
let selectedArr;
let cusArr = new Array();
export default {
  data() {
    return {
      selectedArr: [],
      nameList: [],
      perNum: 0,
    };
  },
  created() {
    let hosItemStr = localStorage.getItem("HosItem");
    let hosItem = JSON.parse(hosItemStr);
    let jsonArry = localStorage.getItem("Type3Arr");
    if (jsonArry == null) {
      cusArr = new Array();
      this.perNum = 0;
    } else {
      cusArr = JSON.parse(jsonArry);
      cusArr.length > 0
        ? (this.perNum = cusArr[0].userSelectCopies)
        : (this.perNum = 0);
    }
    let selectUseExpressType = hosItem.selectUseExpressType;
    let userGetPrintType = selectUseExpressType.bId;
    let hosId = hosItem.hosId;
    console.log(hosId);
    let params = {
      hosId: hosId,
      userGetPrintType: userGetPrintType,
    };
    console.log(params);
    this.getPrintItem(params);
  },
  methods: {
    toggle(index) {
      console.log(this.$refs.checkboxes[index]);
      this.$refs.checkboxes[index].toggle();
      console.log(this.$refs.checkboxes[index].toggle());
      let checked = this.$refs.checkboxes[index].checked;
      console.log(this.$refs.checkboxes[index].checked);
      if (checked) {
        selectedArr[index].userSelectCopies = 0;
      } else {
        let selectNum = this.perNum;
        if (selectNum == 0) {
          perNum = 1;
          selectedArr[index].userSelectCopies = 1;
        } else {
          selectedArr[index].userSelectCopies = selectNum;
          perNum = selectNum;
        }
      }
      this.perNum = perNum;
    },
    getPrintItem(params) {
      console.log("接口前");
      selectedArr = [];
      this.$server.getPrintItem(params).then((res) => {
        console.log("接口后", res);
        if (res.result == 1) {
          console.log(res, "请在下面选择个别内容接口");
          let printItem = res.printItem;
          console.log(printItem.length)
          this.selectedArr = printItem;
           console.log(this.selectedArr.length)
          this.nameList = cusArr.map((x) => {
            return x.itemName;
          });
          console.log(this.nameList);
            for (let i = 0; i <printItem.length;i++) {
            let itemId = printItem[i].itemId;
            let itemName = printItem[i].itemName;
            let itemDes = printItem[i].itemDesc;
            let userSelectCopies;
            if (hasContainByItemId(itemId)) {
              let index = getIndexByItemId(itemId, cusArr);
              userSelectCopies = cusArr[index].userSelectCopies;
              console.log("userSelectCopies:" + userSelectCopies);
              // isChecked = 1;
            } else {
              userSelectCopies = 0;
              // isChecked = 0;
              perNum = 0;
            }
            if (userSelectCopies > 0) {
              perNum = userSelectCopies;
            }

            var itemType = 2;
            var mrInfo_obj = create_item(
              itemType,
              itemId,
              itemName,
              itemDes,
              userSelectCopies,
              false
            );
            selectedArr.push(mrInfo_obj);
            console.log(selectedArr)
            console.log('selectedArr')
          }

          // for (let i in selectedArr) {
          for (let i = 0; i <selectedArr.length;i++) {
            let copysNum = selectedArr[i].userSelectCopies;
            console.log("copysNum:" + copysNum);
            let itemsId = selectedArr[i].itemId;
            console.log("itemsId:" + itemsId);
            if (copysNum > 0) {
              let obj = selectedArr[i];
              obj.checked = true;
              selectedArr.splice(i, 1, obj);
            } else {
              let obj = selectedArr[i];
              obj.checked = false;
              selectedArr.splice(i, 1, obj);
            }
          }
          console.log(selectedArr)
        }
      });
    },
    subCopyNum() {
      perNum = this.perNum;
      if (perNum > 0) {
        perNum--;
        this.perNum = perNum;
        for (let i in selectedArr) {
          if (selectedArr[i].userSelectCopies != 0) {
            selectedArr[i].userSelectCopies = perNum;
          }
        }
      }
    },
    addCopyNum() {
      perNum = this.perNum;
      if (perNum < 8) {
        perNum++;
        this.perNum = perNum;
        console.log(selectedArr,'selectedArr')
        for (let i in selectedArr) {
          if (selectedArr[i].userSelectCopies != 0) {
            selectedArr[i].userSelectCopies = perNum;
          }
        }
        console.log(selectedArr.length,'selectedArr2')
      }
    },
    confirm() {
      var tempArr = new Array();
      console.log(selectedArr)
      for (var i = 0; i < selectedArr.length; i++) {
          var item = selectedArr[i];
          if (item.userSelectCopies > 0) {
            tempArr.push(item);
          }
      }
      console.log(JSON.stringify(tempArr),'00000jojojo')
      if(JSON.stringify(tempArr) == '[]'){
        console.log('Type2Arr为空')
      }else{
        localStorage.setItem("Type2Arr", JSON.stringify(tempArr));
      }
      
	    console.log('tempArr');	
      this.$router.push("purpose");
    },
  },
};

function create_item(itemType, itemId, itemName, itemDesc, copyNum, checked) {
  // var obj = {"mrItemName": itemName, "mItemId": itemId, "mItemDesc":itemDes,"mCopyNum": copyNum}
  var obj = {
    itemType: itemType,
    itemName: itemName,
    itemId: itemId,
    itemDesc: itemDesc,
    userSelectCopies: copyNum,
    checked: checked,
  };
  return obj;
}

function hasContainByItemId(itemId) {
  for (var i = 0; i < cusArr.length; i++) {
    if (cusArr[i].itemId == itemId) {
      return true;
    }
  }
  return false;
}

function getIndexByItemId(itemId, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].itemId == itemId) return i;
  }
  return -1;
}
</script>

<style>
.checkitem {
  background: #fff;
}

.copynum-item {
  width: 60%;
  height: 50px;
  /* text-align: center; */
  margin: auto;
  margin-bottom: 10px;
  margin-top: 20px;
  display: flex;
  display: -webkit-flex;
  background-color: #1aad19;
  justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  border-radius: 5px;
}

.copynum-bg {
  color: #fff;
  background: #1aac19;
  display: flex;
  display: -webkit-flex;
  background-color: #1aad19;
  justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
}

.sub-logo {
  width: 25px;
  height: 25px;
  margin-right: 20px;
}

.add-logo {
  width: 25px;
  height: 25px;
  margin-left: 20px;
}

.text-customize {
  font-size: 15px;
  color: #a2a3a7;
  margin: auto;
  padding: 10px 15px;
  text-align: center;
  justify-content: center;
}

.text-zhu {
  color: #ef7482;
}
</style>
